<i18n>
{
    "ru": {
        "deletedMsg": "Удаленный пользователь",
        "lock_profile": "Закрытый профиль",
        "deleted_message": "Пользователь удалил свой профиль",
        "in": "в",
        "read_more_info": "Подробная информация",
        "my_messages": "Мои сообщения",
        "my_notifications": "Мои уведомления",
        "favorites": "Избранное",
        "show_favorites": "Посмотреть избранное",
        "write_message": "Написать сообщение",
        "subscribe": "Подписаться",
        "current_aroma": "Текущий аромат",
        "select": "Выбрать",
        "change_perfume": "Изменить текущий аромат",
        "select_current_perfume": "Выбрать текущий аромат",
        "history_change_perfumes": "История изменения ароматов",
        "who_whears": "Кто носит этот аромат?",
        "settings_change_data": "Мои данные",
        "settings_notifications": "Уведомления",
        "settings_security": "Безопасность",
        "settings_logout": "Выйти из профиля",
        "my_levels": "Мои значки",
        "levels": "Значки",
        "levels_all": "Все значки",
        "levels_fill": "Получите свой первый значок",
        "about_me": "Рассказать о себе",
        "to_wardrobe": "В гардероб",
        "wardrobe_add": "Добавьте свои любимые ароматы",
        "wardrobe_add_link": "Добавить ароматы",
        "wardrobe_empty": "На этой полке пока нет ароматов",
        "tab_post": "Записи",
        "tab_news": "Новости",
        "tab_articles": "Статьи",
        "tab_reviews": "Отзывы",
        "tab_comments": "Комментарии",
        "loved_perfumes": "Любимые ароматы",
        "perfumes": "ароматы",
        "profile_content": "Материалы",
        "status_update_success": "Статус обновлён",
        "current_perfume_updated": "Текущий аромат обновлён",
        "current_perfume_already_added": "Данный аромат уже установлен",
        "is_subscribed": "Вы подписались на новости о событиях, связанных с данным пользователем",
        "subscribed_request": "Вы отправили запрос на получение новостей о событиях, связанных с данным пользователем",
        "subscribe_already": "Вы уже подписаны на данного пользователя",
        "subscribe_request_already": "Вы уже отправили заявку на подписку этому пользователю",
        "cancel_subscribed_request": "При отмене запроса на подписку пользователь не сможет подтвердить или отклонить вашу заявку."
    }
}
</i18n>

<template>
    <div class="profile-page profile-page__wrapper">
        <Breadcrumb v-if="isDeviceDesktop"
            classModificator="profile-pages"
            :items="breadcrumbs"/>

        <ProfileWrapper :content-full-width="isDeviceDesktop" class="profile-page">

            <ProfileLoginInfoBlock v-if="isUnathorized"
                class="profile-page__login-info-block"
                slot="leftSide" />

            <div slot="content" class="profile-page__block">
                <div :class="profileWrapperClass" class="profile-info__wrapper">
                    <div class="profile-info__content-container">
                        <PageBlock :content-visible="isDeviceDesktop"
                            class="profile-info__content-header">

                            <Breadcrumb v-if="!isDeviceDesktop" :items="breadcrumbs"/>
                            <div class="profile-info" :class="profileInfoClasses">
                                <header class="profile-info__header">

                                    <picture
                                        class="profile-photo-circle"
                                        :class="userPhotoCircleClasses"
                                        @click="onGalleryClick">

                                        <div :class="userPhotoWrapperClasses"
                                            class="profile-photo-circle__wrapper">
                                            <img
                                                v-if="profilePhoto && !isDeleted"
                                                v-lazy-load :data-src="profilePhoto"
                                                alt="" />
                                            <img
                                                v-else
                                                v-lazy-load :data-src="getUserNoImageLarge"
                                                alt="" />
                                        </div>

                                        <div
                                            v-if="isLockStatus"
                                            class="profile-photo-circle__status"
                                            :class="isLock ? 'profile-photo-circle__status_lock' : ''">
                                            <svg-icon
                                                v-if="isLock"
                                                name="icon-lock"/>
                                        </div>
                                    </picture>

                                    <div class="profile-info__header-user-info">
                                        <div class="profile-name">
                                            <div class="profile-name__name">{{ get(profile, 'fullName', 'name') }}</div>
                                            <div class="profile-name__status">
                                                <span>
                                                    {{ get(profile, 'statusText', '') }}
                                                    <span v-if="showChangeStatus"
                                                        @click="changeTextStatus(get(profile, 'statusText', ''))"
                                                        class="profile-name__status-edit">
                                                        <svg-icon name="edit-velvet"/>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                        <ProfileCounts
                                            v-if="isDeviceDesktop && !isDeleted"
                                            :is-personal="isCurrentProfile"
                                            :is-stranger="!isCurrentProfile"
                                            :is-lock="isLock"
                                            :subscriptionNum="subscription"
                                            :subscribersNum="subscribers"
                                            :millilitersNum="milliliters"
                                            :isMillilitersLink="isLinkMl"
                                            :points="points"/>

                                        <div
                                            v-if="!isDeviceDesktop && showSettings"
                                            class="profile-info__settings-btn"
                                            @click="openSettings()">
                                            <svg-icon name="icon-settings"/>
                                        </div>
                                    </div>

                                    <ProfileCounts
                                        v-if="!isDeviceDesktop && !isDeleted"
                                        :is-personal="isCurrentProfile"
                                        :is-stranger="!isCurrentProfile"
                                        :is-lock="isLock"
                                        :subscriptionNum="subscription"
                                        :subscribersNum="subscribers"
                                        :millilitersNum="milliliters"
                                        :isMillilitersLink="isLinkMl"
                                        :points="points"/>

                                </header>

                                <ProfileNavButtonsRow
                                    v-if="!isDeleted && isDeviceDesktop && (isStranger || isUnathorized)"
                                    mode="row"
                                    :user="profile"
                                    :items="navRowItems"
                                    :is-following="isFollowing"
                                    :is-subscribed="isSubscribed"
                                    :is-request-send="isSubscribeRequestSend"
                                    :show-subscribe="showSubscribeButton"
                                    class="profile-info__profile-nav" />

                                <BlockProfileAbout
                                    class="profile-info__block-about"
                                    :is-stranger="isStranger"
                                    :is-deleted="isDeleted"
                                    :show-lock-message="showLockMessage"
                                    :deleted-message="profileDeletedMessage"
                                    :user-about-data="profile" />

                                <footer
                                    v-if="!isDeviceDesktop && !isDeleted"
                                    :class="isLock && isStranger ? 'profile-info__footer_lock' : ''"
                                    class="profile-info__footer">

                                    <ProfileNavButtonsRow
                                        :user="profile"
                                        :items="navRowItems"
                                        :is-following="isFollowing"
                                        :is-subscribed="isSubscribed"
                                        :is-request-send="isSubscribeRequestSend"
                                        :show-subscribe="showSubscribeButton"
                                        class="profile-info__profile-nav" />

                                    <UserCurrentAroma v-if="showCurrentPerfume"
                                        :button-text="$t('select')"
                                        :current-perfume-exist="!!statusPerfume"
                                        @click="addCurrentAroma(statusPerfume)"
                                        :title="$t('current_aroma')"
                                        :picture="get(statusPerfume, 'picture.url', null)"
                                        :alt="get(statusPerfume, 'picture.alt')"
                                        :name="get(statusPerfume, 'name')" />
                                </footer>
                            </div>
                        </PageBlock>

                        <PageBlock
                            class="profile-levels-bonuses__page-block"
                            v-if="showLevels && !isDeleted"
                            smallTitle
                            :content-visible="isDeviceDesktop"
                            :profile-content-width="isDeviceDesktop"
                            :title="isStranger ? $t('levels') : $t('my_levels')">

                            <router-link class="profile-content__link profile-level__link"
                                v-if="isCurrentProfile"
                                :to="{name: 'users.points'}"
                                slot="title-button">
                                {{ $t('levels_all') }}
                            </router-link>

                            <div :data-visible="userContentDataLoaded" class="profile-levels-bonuses">
                                <div class="profile-levels-bonuses__empty-block"
                                    v-if="isCurrentProfile && badges.length < 1">
                                    <span class="profile-levels-bonuses__empty-block-title">{{ $t('levels_fill') }}</span>
                                    <router-link
                                        v-if="isCurrentProfile"
                                        :to="{ name: 'users.settings', hash: '#about' }"
                                        class="profile-levels-bonuses__empty-block-link">
                                        {{ $t('about_me') }}
                                    </router-link>
                                </div>

                                <ul v-else
                                    @scroll="bonusesListScrollInit = true"
                                    :class="bonusesListClass"
                                    class="profile-levels-bonuses__list">
                                    <li
                                        @click="openBadgeModal(item)"
                                        v-for="(item, index) in computedBadges"
                                        :key="`profile-badges_${index}`"
                                        class="profile-badge profile-levels-bonuses__item">
                                        <div v-if="get(item, 'icon.url', null)"
                                            class="profile-badge__icon-wrapper"
                                            v-tooltip="tooltipOptions(item.name)">

                                            <img class="profile-badge__icon-picture"
                                                v-lazy-load :data-src="get(item, 'icon.url', null)"
                                                alt="" />
                                        </div>
                                        <div v-else class="profile-levels-bonuses__item_no-icon"></div>
                                    </li>
                                </ul>
                            </div>
                        </PageBlock>

                        <PageBlock :profile-content-width="isDeviceDesktop"
                            v-if="showWardrobe">
                            <div class="profile-wardrobe">
                                <header class="profile-wardrobe__header">
                                    <h5 class="profile-wardrobe__title">
                                        <router-link
                                            :to="{name: 'WardrobeDetail', params: {
                                                userId: profile.id,
                                                shelfId: wardrobeShelf.id
                                            }}">
                                            {{ computedWardrobeName }}
                                        </router-link>
                                    </h5>
                                    <router-link
                                        :to="wardrobeLink"
                                        class="profile-content__link profile-wardrobe__link">
                                        {{ $t('to_wardrobe') }}
                                    </router-link>
                                </header>
                                <div class="profile-wardrobe__parent-wrapper"
                                    :data-visible="wardrobeLoaded">
                                    <div
                                        v-if="shelfItems && shelfItems.length >= 1"
                                        class="profile-wardrobe__wrapper">
                                        <ul class="profile-wardrobe__list"
                                            @scroll="wardrobeScroll"
                                            :class="wardrobeListClass">
                                            <li
                                                v-for="(item, index) in shelfItems"
                                                :key="`wardrobe-item_${index}`"
                                                @click="openWardrobePerfume(item.perfume)"
                                                class="profile-wardrobe__item">
                                                <img v-lazy-load :data-src="get(item, 'perfume.picture.url', getPerfumeNoImage)"
                                                    v-tooltip="tooltipOptions(get(item, 'perfume.brand.name') + ' ' + get(item, 'perfume.name'))"
                                                    :alt="get(item, 'perfume.picture.alt', '')"/>
                                            </li>
                                        </ul>
                                    </div>

                                    <div
                                        v-else-if="isCurrentProfile && shelfItems && shelfItems.length < 1"
                                        class="profile-wardrobe__no-selected profile-wardrobe__no-selected_self">
                                        <span>{{ $t('wardrobe_add') }}</span>
                                        <router-link class="profile-levels-bonuses__empty-block-link" :to="wardrobeLink">
                                            {{ $t('wardrobe_add_link') }}
                                        </router-link>
                                    </div>

                                    <div
                                        v-else
                                        class="profile-wardrobe__no-selected">
                                        <span>{{ $t('wardrobe_empty') }}</span>
                                    </div>
                                </div>
                            </div>
                        </PageBlock>
                    </div>

                    <div class="profile-info__sticky-container">
                        <UserCurrentAroma v-if="isDeviceDesktop && showCurrentPerfume"
                            class="profile-info__current-aroma"
                            :current-perfume-exist="!!statusPerfume"
                            @click="addCurrentAroma(statusPerfume)"
                            :title="$t('current_aroma')"
                            :picture="get(statusPerfume, 'picture.url', null)"
                            :alt="get(statusPerfume, 'picture.alt')"
                            :name="get(statusPerfume, 'name', undefined)"
                            :button-text="this.$t('select')"/>
                    </div>
                </div>

                <PageBlock
                    class="profile-content__wrapper"
                    :big-title="isDeviceDesktop"
                    :profile-content-width="isDeviceDesktop"
                    :title="isDeviceDesktop ? $t('profile_content') : undefined">
                    <div class="profile-content">
                        <BaseTabs
                            v-model="activeTab"
                            v-if="contentBlockIsLoaded"
                            ref="contentTabs"
                            async-tabs
                            scroll-nav-horizontal
                            id="profileControls"
                            class="profile-content-controls">
                            <BaseTab
                                v-if="showPosts"
                                id="profile-tab-1"
                                :name="$t('tab_post')"
                                :counter="postsTotal">
                                <UserPostsList
                                    v-if="postsLoaded"
                                    :showDrafts="isCurrentProfile"
                                    :showBtn="!isStranger"
                                    :drafts="postsDrafts"
                                    :posts="posts"
                                    :user="profile"
                                    @items-loaded="getUserLikes" />
                                <div v-else class="scroll-loader__tab-preloader">
                                    <img v-lazy-load data-src="/img/loading-sm.gif" alt="" />
                                </div>
                            </BaseTab>

                            <BaseTab
                                id="news"
                                class="profile-content__tab-articles-content"
                                v-if="showNews"
                                :unique-id="false"
                                :name="$t('tab_news')"
                                :counter="newsTotal">
                                <UserArticlesList
                                    :showBtn="!isStranger && get(profile, 'editor', false)"
                                    v-if="newsLoaded"
                                    type="news"
                                    :user="profile"
                                    :drafts="newsDrafts"
                                    :articles="news"
                                    @items-loaded="getUserLikes"/>
                                <div v-else class="scroll-loader__tab-preloader">
                                    <img v-lazy-load data-src="/img/loading-sm.gif" alt="" />
                                </div>
                            </BaseTab>

                            <BaseTab
                                id="articles"
                                class="profile-content__tab-articles-content"
                                v-if="showArticles"
                                :unique-id="false"
                                :name="$t('tab_articles')"
                                :counter="articlesTotal">
                                <UserArticlesList
                                    v-if="articlesLoaded"
                                    type="articles"
                                    component="BlockUserArticle"
                                    :showBtn="!isStranger"
                                    :user="profile"
                                    :drafts="articlesDrafts"
                                    :articles="articles"
                                    @items-loaded="getUserLikes"/>
                                <div v-else class="scroll-loader__tab-preloader">
                                    <img v-lazy-load data-src="/img/loading-sm.gif" alt="" />
                                </div>
                            </BaseTab>

                            <BaseTab
                                id="profile-tab-4"
                                class="profile-content__tab-revews-content"
                                :name="$t('tab_reviews')"
                                :counter="reviewsTotal">
                                <template v-if="reviewsLoaded">
                                    <ScrollLoader :is-loading="tabDataLoad"
                                        v-if="get(userReviews, 'items')"
                                        @onLoad="loadReviewsNextPage">
                                        <BlockFeedUserReview
                                            class="profile-content__tab-item_bordered"
                                            v-for="item in userReviews.items"
                                            :no-photo="isDeleted"
                                            :key="item.id"
                                            :postData="item"/>
                                    </ScrollLoader>
                                    <BlockEmptyPosts :user-name="get(profile, 'fullName')"
                                        :gender="get(profile, 'gender')"
                                        :is-stranger="!isCurrentProfile"
                                        v-else
                                        data-type="review"/>
                                </template>
                                <div v-else class="scroll-loader__tab-preloader">
                                    <img v-lazy-load data-src="/img/loading-sm.gif" alt="" />
                                </div>
                            </BaseTab>

                            <BaseTab
                                id="profile-tab-5"
                                class="profile-content__tab-comments-content"
                                :name="$t('tab_comments')"
                                :counter="commentsTotal">
                                <template v-if="commentsLoaded">
                                    <ScrollLoader v-if="get(userComments, 'items')"
                                        :is-loading="tabDataLoad"
                                        @onLoad="loadCommentsNextPage">
                                        <BlockFeedUserComment
                                            class="profile-content__tab-item_bordered"
                                            :no-photo="isDeleted"
                                            type-only-comments
                                            v-for="comment in userComments.items"
                                            :key="comment.id"
                                            :postData="comment"
                                            :current-user="true"/>
                                    </ScrollLoader>
                                    <BlockEmptyPosts v-else
                                        :gender="get(profile, 'gender')"
                                        :user-name="get(profile, 'fullName')"
                                        :is-stranger="!isCurrentProfile"
                                        data-type="comment"/>
                                </template>
                                <div v-else class="scroll-loader__tab-preloader">
                                    <img v-lazy-load data-src="/img/loading-sm.gif" alt="" />
                                </div>
                            </BaseTab>
                        </BaseTabs>
                        <div v-else class="scroll-loader__tab-preloader">
                            <img v-lazy-load data-src="/img/loading-sm.gif" alt="" />
                        </div>
                    </div>
                </PageBlock>
            </div>
        </ProfileWrapper>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import filter from 'lodash/filter'
import { mapGetters } from 'vuex'
import buttonActions from '@/mixins/catalog/buttonActions'
import userLikes from '@/mixins/userLikes.mixin'

import { handlePromiseRequest } from '@/heplers/asyncDataHelper'

import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import PageBlock from '@/components/layout/AppPageBlock';
import BaseTabs from '@/components/ui/BaseTabs';
import BaseTab from '@/components/ui/BaseTab';
import User from '@/models/users/User';

import UserPostsList from '@/components/users/UserPostsList';
import UserArticlesList from "@/components/users/UserArticlesList";
import ProfileCounts from "@/components/profile/ProfileCounts";
import BlockFeedUserReview from '@/components/feed/blocks/BlockFeedUserReview';
import BlockFeedUserComment from '@/components/feed/blocks/BlockFeedUserComment';

import Article from '@/models/articles/index';
import ProfileWrapper from "@/components/profile/ProfileWrapper";
import UserCurrentAroma from "@/components/profile/UserCurrentAroma";
import BlockProfileAbout from "@/components/profile/BlockProfileAbout";
import ProfileNavButtonsRow from "@/components/profile/ProfileNavButtonsRow";
import ProfileLoginInfoBlock from "@/components/profile/ProfileLoginInfoBlock";
import Account from "@/models/users/accounts/Account";
import UserAccount from "@/models/users/accounts/index";
import Perfume from "@/models/catalog/perfume";
import Shelf from "@/models/users/accounts/Shelf";
import Post from "@/models/Post";
import Draft from "@/models/drafts/BaseDraft";
import News from "@/models/catalog/News";
import Review from "@/models/users/Review";
import Comment from "@/models/users/Comment";
import ScrollLoader from "@/components/ui/ScrollLoader";
import BlockEmptyPosts from "@/components/profile/BlockEmptyPosts";
import Following from "@/models/users/accounts/Following";
import Subscription from '@/models/tags/Subscription'
import Perfumer from "~/models/catalog/Perfumer";

// import Like from '@/models/services/like/'
import AccountStatusPerfumes from "@/models/users/accounts/AccountStatusPerfumes";

export default {
    name: 'Profile',
    // middleware: ['profile'],
    components: {
        BlockEmptyPosts,
        ScrollLoader,
        ProfileLoginInfoBlock,
        ProfileNavButtonsRow,
        BlockProfileAbout,
        UserCurrentAroma,
        ProfileWrapper,
        UserArticlesList,
        PageBlock,
        Breadcrumb,
        BaseTabs,
        BaseTab,
        UserPostsList,
        ProfileCounts,
        BlockFeedUserReview,
        BlockFeedUserComment
    },
    layout: 'LayoutProfile',
    mixins: [buttonActions, userLikes],
    async asyncData({ app, params, query, error }) {
        const baseUrl = app.i18n.__baseUrl;
        // const profileHref = app.router.resolve({
        //     name: 'users.detail'
        // }).href;

        let profilePersonal = false
        let profileStranger = false
        let profileUnlogin = false
        let profileLock = false
        let profileDeleted = false

        let user = null;

        await app.$auth.strategy.token.get();

        // если это собственный аккаунт, то запрашивается приватный эндпоинт
        if (app.$auth.loggedIn && app.$auth.user.id === parseInt(params.userId)) {
            profilePersonal = true
            user = new User();
        }
        // иначе запрашивается публичный эндпоинт
        else {
            profileStranger = true
            user = new User({ id: params.userId });

            if (!app.$auth.loggedIn) {
                profileUnlogin = true
            }
        }

        const requests = [
            user.profile().get(),
            user.badges().get()
        ];

        return handlePromiseRequest(error, requests, (results) => {
            const profile = get(results, '[0][0]', {});
            const badges = get(results, '[1]', []);
            const wardrobeShelf = get(profile, 'perfumeShelves.main', null);

            profileLock = get(profile, 'closedProfile', false);
            profileDeleted = get(profile, 'deletedAccount', false);

            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.home_page'),
                },
                {
                    path: baseUrl + '/users/' + get(profile, 'id', ''),
                    name: get(profile, 'fullName', ''),
                }
            ];

            return {
                breadcrumbs,
                profile,
                badges,
                profilePersonal,
                profileStranger,
                profileUnlogin,
                profileDeleted,
                profileLock,
                wardrobeShelf
            };
        })
    },
    data: () => ({
        activeTab: null,
        breadcrumbs: [],
        aboutListOpened: false,
        profilePersonal: false,
        profileStranger: false,
        profileLock: false,
        profileDeleted: false,
        profileUnlogin: false,
        currentIdentity: null,
        commentsList: null,
        contentBlockIsLoaded: false,
        articles: null,
        articlesDrafts: null,
        posts: null,
        postsDrafts: null,
        news: null,
        newsDrafts: null,
        userComments: null,
        userReviews: null,
        profile: null,
        user: null,
        badges: [],
        popularArticles: [],
        statusPerfume: null,
        wardrobeShelf: {},
        userPostData: {},
        perPage: 10,
        tabDataLoad: false,
        followings: null,
        currentPerfumeDataLoaded: false,
        userContentDataLoaded: false,
        bonusesListScrollInit: false,
        wardrobeListScrollInit: false,
        postsLoaded: false,
        newsLoaded: false,
        articlesLoaded: false,
        reviewsLoaded: false,
        commentsLoaded: false,
        wardrobeLoaded: false
    }),
    fetchOnServer: true,
    globalBus: {
        'user-logout'() {

            this.$modal.hide();

            this.profilePersonal = false
            this.profileStranger = true
            this.profileUnlogin = true

            this.postsLoaded = false;
            this.newsLoaded = false;
            this.articlesLoaded = false;

            this.getUserPosts();
            this.getUserArticles();
            this.getUserNews();

            setTimeout(() => {
                this.initContentTabs()
            }, 1000);

            this.$refs.contentTabs.selectTab('#profile-tab-1')
        },
        'auth-complete'() {
            // this.$fetch();

            this.$nuxt.refresh().then(() => {
                this.getShelvesCollections();
                this.statusPerfume = get(this.profile, 'statusPerfume', null);
                this.currentPerfumeDataLoaded = true;
                this.userContentDataLoaded = true;

                this.postsLoaded = false;
                this.newsLoaded = false;
                this.articlesLoaded = false;

                this.getUserPosts();
                this.getUserArticles();
                this.getUserNews();

                setTimeout(() => {
                    this.initContentTabs()
                }, 1000);

                this.$refs.contentTabs.selectTab('#profile-tab-1')
            })

            // if(this.$auth.loggedIn && this.$auth.user.id === parseInt(this.$route.params.userId)) {
            //     this.profilePersonal = true
            //     this.profileStranger = false
            // }

            // else {
            //     this.profilePersonal = false
            //     this.profileStranger = true
            // }

            // this.profileUnlogin = false;
            // this.profileLock = get(this.profile, 'closedProfile', false);
            // this.profileDeleted = get(this.profile, 'deletedAccount', false);

            // this.postsLoaded = false;
            // this.newsLoaded = false;
            // this.articlesLoaded = false;

            // this.getUserPosts();
            // this.getUserArticles();
            // this.getUserNews();

            // setTimeout(() => {
            //     this.initContentTabs()
            // }, 1000);

            // this.$refs.contentTabs.selectTab('#profile-tab-1')

            // this.$bus.$emit('fetch-complete')
        },
        async 'user-subscribe'() {
            try {
                const user = new User({ id: this.profile.id });

                await new User({user_id: this.profile.id}).for((new UserAccount()), (new Subscription())).save();

                const followingsData = await (new Following()).for(user, (new Account())).get();
                this.followings = get(followingsData, '[0]', null);

                this.$modal.hide();

                if (this.isLock) {
                    this.$alert.success(this.$t('subscribed_request'))
                } else {
                    this.$alert.success(this.$t('is_subscribed'))
                }
            } catch (e) {
                if(e.response.data.code === 'repeat-application-forbidden'){
                    this.$alert.error(e.response.data.message);
                    this.$modal.hide();
                }
                else if(e.response.status === 422) {

                    if(this.isLock) {
                        this.$alert.error(this.$t('subscribe_request_already'));
                        this.$modal.hide();
                        return;
                    }

                    this.$alert.error(this.$t('subscribe_already'));
                    this.$modal.hide();
                }
            }
        },
        'user-unsubscribe'() {
            try {
                const subscriptionId = get(this.followings, 'subscription.id');

                // new User({user_id: this.profile.id})
                //     .for((new UserAccount()), (new Subscription(subscribtionId))).delete();

                new Subscription({id: subscriptionId}).for(new UserAccount()).delete();

                this.$modal.hide();
                if(get(this.followings, 'subscription')) {
                    this.$set(this.followings, 'subscription', null)
                }
            } catch (e) {
                if(e.response.data.code === 'repeat-application-forbidden'){
                    this.$alert.error(e.response.data.message);
                    this.$modal.hide();
                }else{
                    this.$alert.error(this.$t('alerts.error'));
                }
            }
        },
        async 'status-perfume-like'() {

            const model = new User({id: this.profile.id});
            const chainModel = new AccountStatusPerfumes();
            if (!model) return

            const likes = await this.onActionLike(
                !this.statusPerfume.statusPerfumeLiked,
                model,
                false,
                true,
                chainModel,
                true
            )

            this.statusPerfume.statusPerfumeLikes = likes.total
            this.statusPerfume.statusPerfumeLiked = likes.isLiked

            this.$bus.$emit('update-current-perfume-likes', likes)

        },
        'change-text-status'(text) {
            const profileParams = new User().profile();
            // profileParams.status_text = text;

            try {
                profileParams.update({
                    status_text: text
                })

                this.profile.statusText = text;
                this.$alert.success(this.$t('status_update_success'));
                this.$modal.hide();
            }
            catch (e) {
                this.$alert.error(this.$t('alerts.error'));
                this.$modal.hide();
            }

        },
        async 'set-current-perfume'(data) {
            const perfume = get(data, 'perfume', {});
            const userAccount = new UserAccount();
            try {
                await userAccount.setPerfumeStatus({'perfume_code': perfume.code});
                this.statusPerfume = perfume;

                // обновляем инфу о выбранном парфюме
                const user = new User();
                const updatedUserData = await user.profile().get();

                this.statusPerfume = get(updatedUserData, '[0].statusPerfume', this.statusPerfume);

                this.$modal.hide();
                this.$body.uncut();

                this.$alert.success(this.$t('current_perfume_updated'));

            }
            catch (e) {

                const statusCode = get(e, 'response.status', 200);
                if(parseInt(statusCode) === 422) {
                    this.$alert.error(this.$t('current_perfume_already_added'));
                }
            }
        },
        async 'unset-current-perfume'() {
            const userAccount = new UserAccount();
            try {
                await userAccount.unsetPerfumeStatus();
                this.$alert.success(this.$t('current_perfume_updated'));
                this.statusPerfume = null;

                this.$modal.hide()
                this.$body.uncut()
            }
            catch (e) {

                const statusCode = get(e, 'response.status', 200);
                if(parseInt(statusCode) === 422) {
                    this.$alert.error(this.$t('current_perfume_already_added'));
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'isDeviceDesktop',
            'getNoImage',
            'getUserNoImage',
            'getUserNoImageLarge',
            'getPerfumeNoImage',
            'getUserBroadcasts'
        ]),
        profileWrapperClass() {
            return {
                'profile-info__wrapper_deleted': this.isDeleted,
                'profile-info__wrapper_lock-stranger': this.isLock && this.isStranger
            }
        },
        bonusesListClass() {
            return {
                'profile-levels-bonuses__list_scrolling': this.bonusesListScrollInit
            }
        },
        wardrobeListClass() {
            return {
                'profile-wardrobe__list_scrolling': this.wardrobeListScrollInit
            }
        },
        userPhotoCircleClasses() {
            return {
                'users-photo-circle--deleted' : this.isDeleted,
                'users-photo-circle_no-photo' : !get(this.profile, 'photo.url', false)
            }
        },
        canRequestPosts() {
            if(this.isCurrentProfile) return true;

            if(!this.isCurrentProfile && !this.isLock && !this.isDeleted) return true;

            return !this.isLock && this.isCurrentProfile && !this.isDeleted
        },
        wardrobeLink() {
            return { name: 'Wardrobe',
                params: {
                    userId: get(this.profile, 'id')
                }
            }
        },
        showSubscribeButton() {
            return !this.isCurrentProfile
        },
        profileInfoClasses() {
            return {
                'profile-info_is-lock-stranger': this.isLock && this.isStranger,
                'profile-info_is-deleted': this.isDeleted
            }
        },
        isSubscribed() {
            const follower = get(this.followings, 'subscription.entity.id');
            let resultStatus = false;

            if(follower && parseInt(follower) === parseInt(this.profile.id)) {
                resultStatus = true;
            }

            return resultStatus
        },
        isSubscribeRequestSend() {
            const requestSend = get(this.followings, 'subscription.requestSent', false);
            let resultStatus = false;

            if(requestSend) {
                resultStatus = true;
            }

            return resultStatus
        },
        isFollowing() {
            const follower = get(this.followings, 'follower.entity.id');
            let resultStatus = false;

            if(follower && parseInt(follower) === parseInt(this.profile.id)) {
                resultStatus = true;
            }

            return resultStatus
        },
        postsTotal() {
            return get(this.posts, 'total', 0) + get(this.postsDrafts, 'total', 0)
        },
        articlesTotal() {
            return get(this.articles, 'total', 0) + get(this.articlesDrafts, 'total', 0)
        },
        newsTotal() {
            return get(this.news, 'total', 0) + get(this.newsDrafts, 'total', 0)
        },
        reviewsTotal() {
            return get(this.userReviews, 'total', 0)
        },
        commentsTotal() {
            return get(this.userComments, 'total', 0)
        },
        computedWardrobeName() {
            if(this.wardrobeShelf && this.wardrobeShelf.default) {
                return get(this.wardrobeShelf, 'name', null) + ' ' + this.$t('perfumes');
            }

            return get(this.wardrobeShelf, 'name', this.$t('loved_perfumes'));
        },
        userPhotoWrapperClasses() {
            if(this.isDeleted) return;
            if(!this.isCurrentProfile && this.isLock) return;

            const userIsOnline = get(this.profile, 'isOnline', false)
            const isInActive = !userIsOnline &&
                dayjs().unix() < dayjs(get(this.profile, 'lastOnlineAt')).unix() + 3600 * 24
            return {
                'profile-photo-circle__wrapper_online': this.isStranger && !!userIsOnline,
                'profile-photo-circle__wrapper_inactive': this.isStranger && isInActive,
                'profile-photo-circle__wrapper_no-photo' : !get(this.profile, 'photo.url', false)
            }
        },
        navRowItems() {
            let items = this.isStranger && !this.isLock || this.isCurrentProfile ? [
                {
                    title: this.favoritesMessage,
                    iconName: 'icon-heart-fill',
                    route: {
                        name: 'users.favorites',
                        params: {
                            userId: this.currentUserId
                        }
                    },
                    authRequired: false
                }
            ] : [];

            items = [
                ...items,
                {
                    title: this.isCurrentProfile ? this.$t('my_messages' ) : this.$t('write_message'),
                    iconName: "icon-mail",
                    counter: this.isCurrentProfile ? this.unreadMessagesCounter : null,
                    route: {
                        name: this.isCurrentProfile ? 'users.messages' : 'users.messages.dialog',
                        params: {
                            userId: get(this.$auth, 'user.id'),
                            secondUserId: this.profile.id
                        }
                    },
                    authRequired: true
                }
            ]

            if(this.navMessages) {
                items = [
                    ...items,
                    {
                        title: this.$t('my_notifications'),
                        iconName: 'icon-bell-fill',
                        counter: this.unreadNoticeCounter,
                        route: {
                            name: 'Notifications',
                            params: {
                                userId: this.currentUserId
                            }
                        }
                    }
                ]
            }

            return items
        },
        wrapperClasses() {
            return {
                'profile-page__wrapper_locked': this.isLock
            }
        },
        currentUserId() {
            return get(this.profile, 'id', null)
        },
        dateDeleted() {
            return dayjs(get(this.profile, 'deletedAt')).format(`DD.MM.YYYY ${this.$t('in')} hh:mm`)
        },
        profileName() {
            return get(this.profile, 'fullName', 'name')
        },
        profilePhoto() {
            return get(this.profile, 'photo.url', this.getUserNoImageLarge)
        },
        profileCounts() {
            return get(this.profile, 'statistics.profileCounts', [])
        },
        shelfItems() {
            return get(this.wardrobeShelf, 'items', [])
        },
        level() {
            return 2
        },
        points() {
            return get(this.profile, 'ratings.points.total', 0);
        },
        subscription() {
            return get(this.profile, 'subscriptions.total', 0);
        },
        subscribers() {
            return get(this.profile, 'followers.total', 0);
        },
        milliliters() {
            return get(this.profile, 'ml.amount', 0);
        },
        profileDeletedMessage() {
            return `${this.$t('deleted_message')} <br/> ${this.dateDeleted}`
        },
        isStranger() {
            return this.profileStranger
        },
        isDeleted() {
            return this.profileDeleted
        },
        isLock() {
            return this.profileLock
        },
        isUnathorized() {
            return this.profileUnlogin
        },
        isCurrentProfile() {
            return !!this.profilePersonal
        },
        isLockStatus() {
            return this.isStranger || this.isLock && this.isCurrentProfile
        },
        showCurrentPerfume() {
            if(!this.currentPerfumeDataLoaded) return;

            return this.profilePersonal ||
                this.profilePersonal && this.profileLock
                || this.profileStranger && !this.profileLock && this.statusPerfume
        },
        showLevels() {
            if (this.isCurrentProfile) {
                return true;
            } else {
                return !!(this.points && this.points >= 100)
            }
        },
        showChangeStatus() {
            return this.isCurrentProfile && !this.isDeleted
        },
        showSettings() {
            return this.isCurrentProfile && !this.isDeleted
        },
        showLockMessage() {
            return this.isLock && !this.isCurrentProfile
        },
        showWardrobe() {
            if(this.isCurrentProfile) {
                return true;
            }

            if(this.isLock) {
                return false;
            }

            return !this.isDeleted
        },
        showArticles() {
            if(!this.isCurrentProfile){
                return get(this.articles, 'total', 0) > 0 || get(this.articlesDrafts, 'total', 0) > 0
            }else{
                return true
            }
        },
        showNews() {
            if(get(this.profile, 'editor', false) && this.isCurrentProfile)
                return true

            return get(this.news, 'total', 0) > 0 || get(this.newsDrafts, 'total', 0) > 0
        },
        showPosts() {
            if(this.isLock && !this.isCurrentProfile) return false;

            if(this.isCurrentProfile) return true;

            if(this.isUnathorized && get(this.posts, 'items.length', false)) return true;

            return !this.isCurrentProfile
                    && get(this.posts, 'items.length', false);
        },
        favoritesMessage() {
            let message = this.$t('show_favorites')
            if (this.isCurrentProfile) {
                message = this.$t('favorites')
            }
            return message
        },
        navMessages() {
            return this.isCurrentProfile && !this.isStranger
        },
        isLinkMl() {
            return !this.isStranger || !this.isDeleted || !this.isLock
        },
        computedBadges(){
            const computedItems = this.badges
            if (this.isCurrentProfile && this.profile.ratings && this.profile.ratings.points && this.profile.ratings.points.level === 1)
                computedItems.find(item => item.code === 'rating').bonuses = {pointsValue: 100}
            return computedItems
        },
        unreadNoticeCounter(){
            return get(this.getUserBroadcasts, 'notifications.unread.total', null)
        },
        unreadMessagesCounter(){
            return get(this.getUserBroadcasts, 'chats.messages.unread.total', null)
        }
    },
    created() {
        this.getShelvesCollections();
        this.statusPerfume = get(this.profile, 'statusPerfume', null);
        this.currentPerfumeDataLoaded = true;
        this.userContentDataLoaded = true;

        this.loadContentBlockData();
    },
    methods: {
        get,
        loadReviewsNextPage: throttle(function() {
            if(this.tabDataLoad === true) return;

            if(this.userReviews && this.userReviews.nextPageUrl) {
                this.tabDataLoad = true;

                this.$api.get(this.userReviews.nextPageUrl)
                    .then((response) => {
                        this.read(response.data, this.userReviews);
                    }).finally(() => {
                        this.tabDataLoad = false;
                    });
            }
        }, 1000),
        loadCommentsNextPage: throttle(function() {
            if(this.tabDataLoad === true) return;

            if(this.userComments && this.userComments.nextPageUrl) {
                this.tabDataLoad = true;

                this.$api.get(this.userComments.nextPageUrl)
                    .then((response) => {
                        this.read(response.data, this.userComments);
                    }).finally(() => {
                        this.tabDataLoad = false;
                    });
            }
        }, 1000),
        read(data, object) {
            if(object && object.items && data.items) {
                object.items = [
                    ...object.items,
                    ...data.items
                ]
            }

            this.getUserCommentsLikes(data.items, 'comment', true)

            object.nextPageUrl = get(data, 'nextPageUrl', null)
        },
        async loadContentBlockData() {
            if (this.contentBlockIsLoaded) return;
            
            const requests = [
                this.getUserArticles(),
                this.getUserNews(),
                this.getUserReviews(),
                this.getUserComments()
            ]

            if (process.client) {
                if (this.profileStranger && this.$auth.loggedIn) {
                    const user = new User({
                        id: this.profile.id
                    });
                    requests.push((new Following()).for(user, (new Account())).get());
                }
            }

            if (this.canRequestPosts) {
                requests.push(this.getUserPosts())
            } else {
                this.postsLoaded = true;
            }

            await Promise.all(requests).then((results) => {

                this.followings = get(results, '[4][0]');
                const entityItems = [
                    ...get(this.posts, 'items', []),
                    ...get(this.articles, 'items', []),
                    ...get(this.news, 'items', [])
                ]

                const comments = [
                    ...get(this.userComments, 'items', []),
                    ...get(this.userReviews, 'items', [])
                ]

                this.getUserLikes(entityItems)
                this.getUserCommentsLikes(comments)
                this.contentBlockIsLoaded = true
            })

        },
        initContentTabs() {
            this.$nextTick(() => {
                if (this.$refs.contentTabs) {
                    this.$refs.contentTabs.init()
                }
            });
        },
        async getUserNews() {
            let posts = {};
            let drafts = {};

            const user = new User({ id: this.$route.params.userId });

            if(this.isCurrentProfile) {
                const draftObject = new Draft().params({per_page: this.perPage, from_published_news: 'n'});
                drafts = await draftObject.for((new User), (new Account), (new News)).get();
            }

            posts = await (new News().params({per_page: this.perPage})).for(user, (new Account)).get();

            this.news = get(posts, '[0]', {});
            this.newsDrafts = get(drafts, '[0]', {});

            this.newsLoaded = true;
            this.initContentTabs();
        },
        async getUserPosts() {

            let posts = {};
            let drafts = {};

            const user = new User({ id: this.$route.params.userId });

            if(this.isCurrentProfile) {
                const draftObject = new Draft().params({per_page: this.perPage, from_published_posts: 'n'});
                drafts = await draftObject.for((new User), (new Account), (new Post)).get();
            }

            posts = await (new Post().params({per_page: this.perPage})).for(user, (new Account)).get();

            this.posts = get(posts, '[0]', {});
            this.postsDrafts = get(drafts, '[0]', {});

            this.postsLoaded = true;
            this.initContentTabs()
        },
        async getUserArticles() {
            let result = {};
            let drafts = {};

            const user = new User({ id: this.profile.id });

            if(this.isCurrentProfile) {
                drafts = await (new Draft().params({per_page: this.perPage, from_published_articles: 'n'})).for((new User), (new Account), (new Article)).get();
            }

            result = await (new Article().params({per_page: this.perPage})).for(user, (new Account)).get();

            const articlesDrafts = get(drafts, '[0]', {});
            const articles = get(result, '[0]', {});

            this.articles = articles;
            this.articlesDrafts = articlesDrafts;

            this.articlesLoaded = true;
            this.initContentTabs()
        },
        async getUserReviews() {
            let result = {};

            const user = new User({ id: this.profile.id });

            result = await (new Review().params({per_page: this.perPage})).for(user, (new Account)).get();

            const reviews = get(result, '[0]', {});

            this.userReviews = reviews;

            this.reviewsLoaded = true;
            this.initContentTabs()
        },
        async getUserComments() {
            let result = {};

            const user = new User({ id: this.profile.id });

            result = await (new Comment().params({per_page: this.perPage})).for(user, (new Account)).get();

            const comments = get(result, '[0]', {});

            this.userComments = comments;

            this.commentsLoaded = true;
            this.initContentTabs()
        },
        getCurrentIdentity() {
            const profileIdentity = [
                this.profileStranger,
                this.profileUnlogin,
                this.profileDeleted,
                this.profileLock,
                this.profilePersonal
            ]
            const current = filter(profileIdentity, (item) => item === true)
            return current
        },
        async getShelvesCollections() {
            const accountModel = new Account();
            let userModel = new User();

            if(!this.isCurrentProfile) {
                userModel = new User({ id: get(this.profile, 'id', 0) });
            }

            if(this.wardrobeShelf && this.wardrobeShelf.id) {
                const shelf = new Shelf({id: this.wardrobeShelf.id})
                const shelvePerfumesResult = await new Perfume().for(userModel, accountModel, shelf).get()
                const shelvePerfumesItems = get(shelvePerfumesResult, '[0].items', []);
                this.$set(this.wardrobeShelf, 'items', shelvePerfumesItems);
            }

            this.wardrobeLoaded = true;
        },
        onGalleryClick() {
            if(!get(this.profile, 'photo.url', false)) return false;

            const picture = get(this.profile, 'photoThumbs.x.url', get(this.profile, 'photo.url'))

            this.showPopup('gallery', {
                title: this.profileName,
                pictures: [
                    {
                        url: picture,
                        alt: ''
                    }
                ],
                user: {
                    fullName: get(this.profile, 'fullName'),
                    photo: {
                        url: picture
                    }
                }
            });
        },
        openSettings() {
            const modalItems = [
                {
                    name: this.$t('settings_change_data'),
                    linkUrl: `/users/${this.currentUserId}/settings#data`
                },
                {
                    name: this.$t('settings_notifications'),
                    linkUrl: `/users/${this.currentUserId}/settings#notifications`
                },
                {
                    name: this.$t('settings_security'),
                    linkUrl: `/users/${this.currentUserId}/settings#security`
                },
                {
                    name: this.$t('settings_logout'),
                    customClass: 'popup-actions__link_danger',
                    eventName: 'user-logout'
                }
            ];

            this.showPopup('actions', {
                modalItems,
                titleType: 'settings'
            });
        },
        changeTextStatus(status) {
            this.showPopup('change-text-status', {currentStatus: status})
        },
        openBadgeModal(badge) {
            this.showPopup('badge-info', {
                badgeData: badge,
                ratings: get(this.profile, 'ratings', {})
            })
        },
        async openWardrobePerfume(item) {
            if(item && item.code) {
                const perfumeDetailData = await new Perfume().find(item.code);
                const perfumersResponse = await new Perfumer()
                    .for((new Perfume({code: item.code}))).get();
                const perfumers = get(perfumersResponse, '[0]', null)

                this.showPopup('card-perfume', {
                    cardData: item,
                    perfumeDetailData,
                    perfumers
                })
            }
        },
        addCurrentAroma(perfume) {
            
            if(!perfume && !this.isCurrentProfile) return

            if(perfume) {
                let modalItems = [];

                if(this.isCurrentProfile) {
                    modalItems = [
                        {
                            name: this.$t('change_perfume'),
                            modal: 'modal-wardrobe-add-perfume',
                            data: {
                                titleType: 'change',
                                currentPerfume: perfume
                            }
                        },
                        {
                            name: this.$t('history_change_perfumes'),
                            modal: 'history-perfume'
                        }
                    ]
                }

                modalItems = [
                    ...modalItems,
                    {
                        name: this.$t('who_whears'),
                        modal: 'perfume-wear',
                        data: {
                            perfume,
                        },
                        count: get(perfume, 'whoWears.total', null),
                        disabled: get(perfume, 'whoWears.total', 0) < 1,
                        customClass: get(perfume, 'whoWears.total', 0) < 1 ? 'popup-current-perfume__link_disabled' : '',
                    }
                ];

                this.showPopup('current-perfume', {
                    modalItems,
                    headerData: perfume,
                    modalType: 'settings',
                    showLike: true
                });
            } else {
                this.showPopup('modal-wardrobe-add-perfume', {
                    name: this.$t('select_current_perfume'),
                    modalType: 'change'
                });
            }
        },
        onReviewClick() {
            this.$authEmit('open-popup-review-brand');
        },
        tooltipOptions(name) {
            const desktopOptions = {
                content: name,
                delay: { show: 50, hide: 50 },
                offset: 8,
                defaultPlacement: 'bottom',
                boundariesElement: 'body'
            }
            return this.isDeviceDesktop ? desktopOptions : {}
        },
        wardrobeScroll(){
            if(!this.wardrobeListScrollInit)
                this.wardrobeListScrollInit = true
            document.querySelectorAll('.tooltip').forEach(elem => {elem.style.display = 'none'})
        }
    },
    head() {
        return {
            title: this.$options.filters.metaSitenameTitle(get(this.profile, 'fullName'))
        }
    }
}
</script>

<style lang="less">

.profile-page {
    margin-bottom: rem(50);

    @{mobile} & {
        margin-bottom: rem(16);
    }

    .page-block {
        --desktop-header-padding-bottom: rem(16);
    }

    &__login-info-block {
        position: sticky;
        top: rem(20);
    }
    

    .scroll-loader {
        &__tab-preloader {
            text-align: center;

            padding-top: rem(46);

            height: rem(104);
            width: 100%;

            @{desktop} & {
                height: rem(300);
            }
        }
    }
}

.profile-info {
    position: relative;
    @profile-locked : ~".profile-page__wrapper_locked";

    @{desktop} & {
        border-bottom: rem(1) solid @color-gray-white;
    }

    @{profile-locked} & {
        @{desktop} & {
            border-bottom: none;
        }
    }

    &_is-lock-stranger {
        @{desktop} & {
            border-bottom: none;
        }
    }

    &_is-deleted {
        @{desktop} & {
            border-bottom: none;
        }
    }

    &__content-header {
        @{desktop} & {
            width: rem(616);
        }
    }

    &__wrapper {

        &_deleted {
            .profile-info__content-header {
                margin-bottom: 0;
                padding-bottom: rem(14);
            }
        }

        &_lock-stranger {
            .profile-info__block-about {
                @{desktop} & {
                    border-bottom: none;
                }
            }
        }

        @{desktop} & {
            display: flex;
            width: 100%;
            position: relative;
        }
    }

    &__sticky-container {
        width: 100%;
        padding-left: rem(20);
        position: relative;

        @{desktop} & {
            padding-bottom: rem(20);
        }
    }

    &__header {
        display: flex;
        flex-flow: row wrap;
        padding: 0 rem(20) rem(12);

        &-user-info {
            flex: 1;
            margin-left: rem(16);
        }

        @{desktop} & {
            flex-flow: row;
            padding: 0 0 rem(12);

            &-user-info {
                margin-left: rem(40);
            }
        }
    }

    &__current-aroma {
        cursor: pointer;

        @{desktop} & {
            position: sticky;
            top: rem(20);
            left: 79%;
        }
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: rem(16);
        padding-left: rem(20);
        @media @media-less-375{
            padding-left: rem(16);
        }

        &_lock {
            padding-top: rem(14);
        }
    }

    &__settings-btn {
        cursor: pointer;
        height: 20px;
        width: 20px;
        position: absolute;
        top: rem(8);
        right: rem(20);
        z-index: 3;

        svg {
            max-height: 100%;
            max-width: 100%;
        }
    }

    &__profile-nav {
        margin-top: rem(10);
        margin-bottom: rem(7);
    }
}

.profile-photo-circle {
    --profile-photo-size: rem(64);
    height: var(--profile-photo-size);
    width: var(--profile-photo-size);
    flex: 0 0 var(--profile-photo-size);
    position: relative;

    @{desktop} & {
        --profile-photo-size: rem(122);
    }

    &__wrapper {
        background-color: @color-gray-light-2;
        border-radius: 50%;
        height: var(--profile-photo-size);
        width: var(--profile-photo-size);
        overflow: hidden;

        .hover({
            cursor: pointer;
        });

        &:after {
            display: flex;
            align-items: center;
            justify-content: center;
            border: rem(1) solid @color-white;
            border-radius: 50%;
            height: rem(14);
            width: rem(14);
            position: absolute;
            right: rem(2);
            bottom: rem(2);

            @{desktop} & {
                border: rem(3) solid @color-white;
                height: rem(22);
                width: rem(22);
                right: rem(5);
                bottom: rem(5);
            }
        }

        &_online {
            &:after {
                content: '';

                background-color: @color-green;
            }
        }

        &_inactive {
            &:after {
                content: '';
                background-color: @color-orange;
            }
        }

    }

    &.users-photo-circle_no-photo{

        .hover({
            cursor: default;
        });

        .profile-photo-circle__wrapper{
            .hover({
                cursor: default;
            }); 
        }
    }

    img {
        object-fit: cover;
        border-radius: 50%;
        height: 100%;
        width: 100%;
    }

    &__status {

        &_lock {
            background-color: @color-intense-blue;
            border-radius: 50%;
            text-align: center;
            height: rem(22);
            width: rem(22);
            position: absolute;
            right: rem(-1);
            bottom: rem(-1);

            svg {
                max-height: rem(12);
                max-width: rem(12);
            }

            @{desktop} & {
                right: rem(5);
                bottom: rem(5);
            }
        }
    }

    &__icon {
        max-height: 20px;
        max-width: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.profile-info-counts {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    justify-content: space-evenly;
    padding-top: rem(14);
    width: 100%;

    @{desktop} & {
        flex: 1;
        justify-content: flex-start;
    }
}

.profile-name {
    line-height: 1.5;
    padding-top: rem(7);

    @{desktop} & {
        line-height: 1.3;
        padding-top: 0;
        padding-bottom: rem(14);
    }

    &__name {
        font-size: rem(18);
        font-weight: 500;
        hyphens: auto;
        text-overflow: ellipsis;
        word-break: break-word;
        margin-bottom: rem(2);
        width: 100%;
        max-height: calc(27px * 2);
        overflow: hidden;
        .text-ellipsis(2);

        @{desktop} & {
            font-size: rem(28);
            hyphens: none;
            word-break: normal;
            margin-bottom: rem(7);
            max-height: inherit;
        }
    }

    &__status {
        color: @color-gray;
        font-size: rem(14);

        @media @media-less-375 {
            font-size: rem(13);
        }

        @{desktop} & {
            font-size: rem(15);
        }

        &-edit {
            display: inline-block;
            cursor: pointer;
            margin-left: rem(5);
            height: rem(14);
            width: rem(14);
            position: relative;
            top: rem(2);

            svg {
                max-height: 100%;
                max-width: 100%;
                display: block;
            }

            @{desktop} & {
                &:hover{
                    opacity: .7;
                }
            }
        }
    }
}

.profile-levels-bonuses {
    position: relative;
    overflow: hidden;
    opacity: 0;
    .animate(opacity);

    @{desktop} & {
        overflow: visible;
    }

    &[data-visible="true"] {
        opacity: 1;
    }

    &__page-block {
        border-bottom: rem(1) solid @color-gray-white;

        .page-block__header {
            padding-top: rem(18);

            @{desktop} & {
                padding-bottom: rem(14);
            }
        }
    }

    &__list {
        font-size: 0;
        list-style: none;
        white-space: nowrap;
        margin: 0;
        padding: rem(10) rem(20) rem(20);
        padding-right: 0;
        min-width: 100vw;
        .scrollbarHorizontal();

        @{desktop} & {
            padding-top: 0;
            padding-bottom: rem(14);
            padding-left: 0;
            width: 100%;
            min-width: auto;
        }

        &::after {
            .gradient(right);
            right: rem(0);
            z-index: 1;
            .animate(background);
        }

        &_scrolling {
            &::before {
                .gradient(left);
                left: rem(-1);
                z-index: 1;
                .animate(background);
            }
        }
    }

    &__fill {
        display: block;
        text-align: center;
        padding: rem(25) rem(20);
        width: 100%;
    }

    &__item {
        @{desktop} & {
            cursor: pointer;
            margin: 0 rem(16) rem(12) 0;
        };

        &_no-icon {
            background: @color-gray-2;
            border-radius: 50%;

            height: 100%;
            width: 100%;
        }
    }

    &__empty-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: @color-gray-light;
        padding: rem(12) 0 rem(20);

        &-link {
            color: @color-primary;
            margin-top: rem(12);
            .hover({
                text-decoration: underline;
            })
        }
    }
}

.profile-badge {
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    border-radius: 50%;
    margin-right: rem(16);
    height: rem(48);
    width: rem(48);
    position: relative;

    // fix blurry img in safari
    &__icon-picture {
        height: rem(48);
        width: rem(48);

        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi){
            transform: scale(.5);
            width: 200%;
            height: 200%;
            transform-origin: 0 0
        }
    }

    &__icon {
        fill: @color-white;
        height: rem(15);
        width: rem(15);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &:last-of-type {
        margin-right: rem(22);
    }
}

.profile-level,
.profile-rating {
    display: inline-block;
    vertical-align: middle;
    border: 2px solid transparent;
    border-radius: 50%;
    font-size: rem(13);
    font-weight: 500;
    margin-right: rem(16);
    height: rem(44);
    width: rem(44);
    position: relative;

    @{desktop} & {
        height: rem(48);
        width: rem(48);
    }

    a, &__level-block {
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-black;
        text-overflow: ellipsis;
        padding-top: rem(2);
        height: rem(40);
        width: rem(40);
        overflow: hidden;

        @{desktop} & {
            height: rem(45);
            width: rem(45);
        }
    }

    &__icon {
        content: "";
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        padding: rem(4);
        height: rem(20);
        width: rem(20);
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(30%, -30%);

        svg {
            fill: @color-white;
            max-height: 100%;
            max-width: 100%;
        }
    }
}

.profile-level {
    border-color: @color-violet;

    &__icon {
        background-color: @color-violet;
    }

    &__link {
        color: @color-violet;
        white-space: nowrap;
    }
}

.profile-rating {
    border-color: @color-orange;

    &__icon {
        background-color: @color-orange;
    }
}

.profile-wardrobe {
    padding-top: rem(19);
    padding-bottom: rem(19);

    @{desktop} & {
        border-bottom: rem(1) solid @color-gray-white;
        padding-top: rem(11);
        padding-bottom: rem(18);
    }

    &__header {
        display: grid;
        grid-template-columns: 71% 29%;
        margin-bottom: rem(14);
        .page-padding();
    }

    &__title {
        font-size: rem(16);
        margin: 0;

        @{desktop} & {
            font-size: rem(18);
        }

        a{
            color: @color-black;
            &:hover{
                color: @color-primary;
            }
        }
    }

    &__link {
        color: @color-violet;
        font-size: rem(14);
        text-align: right;
        white-space: nowrap;

        svg {
            display: inline-block;
            vertical-align: middle;
            fill: none;
            stroke: @color-violet;
            height: rem(16);
            width: rem(16);
            transform: translateX(rem(-2));
        }

        @{desktop} & {
            text-align: right;

            svg {
                display: none;
            }
        }
    }

    &__list {
        list-style: none;
        white-space: nowrap;
        margin: 0;
        .page-padding();
        .scrollbarHorizontal();

        @{desktop} & {
            width: 100%;
        }

        &::after {
            .gradient(right);
            right: rem(-1);
            z-index: 1;
        }

        &_scrolling {
            &::before {
                .gradient(left);
                left: rem(-1);
                z-index: 1;
            }
        }
    }

    &__item {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        text-align: center;
        margin-right: rem(16);
        height: rem(64);
        width: rem(64);

        @{desktop} & {
            height: rem(71);
            width: rem(71);
        }

        img {
            height: 100%;
            max-height: 100%;
            max-width: 100%;
        }
    }

    &__wrapper {
        width: 100%;
        position: relative;

        @{desktop} & {
            margin-top: rem(26)
        }
    }

    &__parent-wrapper {
        opacity: 0;
        .animate(opacity);

        &[data-visible="true"] {
            opacity: 1;
        }
    }

    &__no-selected {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        color: @color-gray-light;
        font-size: rem(15);
        line-height: 1.5;
        padding: rem(20) 0;

        a {
            display: inline-block;
            color: @color-violet;
            margin-top: rem(5);
        }

        @{desktop} & {
            padding: rem(22) 0 rem(28);
        }

        &_self {
            padding: rem(8) 0;

            @{desktop} & {
                padding: rem(18) 0 rem(32);
            }
        }
    }
}

.profile-content {

    &__tab-revews-content, &__tab-comments-content {
        @{desktop} & {
            padding-top: rem(10);
        }
    }

    &__tab-articles-content {
        @{desktop} & {
            padding-top: rem(10)
        }
    }

    &__tab-item_bordered {
        border-bottom: rem(1) solid @color-gray-white;

        &.feed-post{
            border-top: none;
        }
    }

    &__wrapper {
        @{desktop} & {
            padding-top: rem(7);
        }
    }

    &-controls {
        .tabs__nav {
            margin-bottom: 0;

            position: relative;

            .scrollbar-hidden();
        }

        .tabs__panels {
            padding: 0;
        }

        .tabs__link {
            padding: rem(10) 0 rem(11);
        }

        .tabs__tab + .tabs__tab {
            margin-left: rem(28)
        }
    }

    &__link {
        color: @color-violet;
        font-size: rem(14);
        white-space: nowrap;

        .hover({
            text-decoration: underline;
        });

        @{desktop} & {
            font-size: rem(15);
        }
    }
}

// TODO tmp...

.feed-post {
    --photo-width: rem(70);
    --photo-height: rem(41);
    padding: rem(22) rem(20);
    transition-duration: .6s;
    transition-property: opacity;
    transition-timing-function: ease;

    @{desktop} & {
        padding: rem(22) 0;
    }

    &:not:first-child {
        border-top: rem(1) solid @color-gray-white;
    }

    &:not(&__reply) + & {
        border-top: rem(1) solid @color-gray-white
    }

    &:first-child{
        border-top: none !important;
    }

    &__expert {
        margin-left: rem(5);
        height: rem(16);
        width: rem(16);
        position: absolute;
        top: rem(1)
    }

    &__reply {
        box-shadow: inset 2px 0px 0px #ECECEC;
        margin-top: rem(16);
        padding-top: rem(16);
        padding-bottom: rem(16)
    }

    &__pictures {
        display: flex;
        margin-top: rem(12);
        margin-bottom: rem(16);

        picture {
            display: block;
            cursor: pointer;

            img {
                object-fit: cover;
                border-radius: rem(3);
                height: rem(56);
                width: rem(56);
            }

            & + picture {
                margin-left: rem(12);
            }
        }
    }

    &__data {
        color: @color-black;

        &-name {
            font-size: rem(15);
            margin-bottom: 0;
            height: rem(22.5);
            max-width: rem(132);
            position: relative;

            @media @min375 {
                max-width: initial;
            }

            b {
                margin-right: rem(6);
            }
        }

        &-date {
            color: @color-gray;
            font-size: rem(13);
        }
    }

    &__help {
        transform: translateY(rem(-2));
    }

    &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__content {
        line-height: 155%;
        padding-top: rem(10);
    }

    &__content + &__buttons,
    &__content + &__bottom {
        margin-top: rem(14);
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: rem(16) 0 0;
    }

    &__button-show-replies {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: @color-gray-light-2;
        border: none;
        border-radius: rem(3);
        color: @color-black;
        font-size: rem(13);

        padding: rem(6) rem(10);

        @media @min375 {
            padding: rem(6) rem(16);
        }
    }

    &__reply-to,
    &__go-to {
        background: none;
        border: none;
        color: @color-gray-light;
        margin-left: auto;
        padding: 0;
    }

    &__go-to {
        font-size: rem(14);
        margin-left: rem(8);

        @media @min375 {
            font-size: rem(15);

            margin-left: rem(20);
        }
    }

    &__show-user-comments {
        margin-bottom: rem(10);
    }
}

.tmp-change-view {
    display: flex;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: rem(5);

    a {
        display: inline-block;
        background-color: #efefef;
        font-size: 12px;
        padding: 5px;

        &.is-active {
            background-color: @color-violet;
            color: @color-white;
        }
    }
}

.user-posts,
.user-articles{
    &__button-review{
        &:not([disabled]){
            &:hover{
                background-color: @color-gray-white;
            }
        }
    }
}

.profile-badge__icon-wrapper{
    &:hover{
        opacity: .9;
    }
}

</style>
